import { PersonTypes } from "../../../DTOs";
import { basicValidation } from "../basicValidation";
import { fieldValidation } from "../fieldValidation";

export const locationFieldValidation = {
    location : {
        id: (value:string) =>  basicValidation.resourceId.isValid(value),
        name: (value:string) =>  basicValidation.resourceText.isValid(value, false, 100),
        country: (value:string) =>  basicValidation.resourceText.isValid(value, true, 100),
        address: (value:string) =>  basicValidation.resourceText.isValid(value, true, 200),
        postalCode: (value:string) =>  basicValidation.resourceText.isValid(value, true, 20),
        city: (value:string) =>  basicValidation.resourceText.isValid(value, true, 100),
        created:basicValidation.date
    },

    facility : {
        id: (value:string) =>  basicValidation.resourceId.isValid(value),
        name: (value:string) =>  basicValidation.resourceText.isValid(value, false, 100),
        building: (value:string) =>  basicValidation.resourceText.isValid(value, true, 100),
        floor: (value:string) =>  basicValidation.resourceText.isValid(value, true, 100),
        type: (value:string) => {
            return fieldValidation.facilityType.id(value);
        },
        personIdOrEmpty: (id:string) =>  basicValidation.resourceId.isValidOrEmpty(id),
        locationId: (value:string) =>  basicValidation.resourceId.isValid(value),
        created:basicValidation.date
    },

    facilityType: {
        id: (value:string) =>  basicValidation.resourceId.isValid(value),
        name: (value:string) =>  basicValidation.resourceText.isValid(value, false, 100),
        disabled: basicValidation.validateBoolean
    },

    person : {
        id: (value:string) =>  basicValidation.resourceId.isValid(value),
        type: (value:string) => {
            const maybeType = PersonTypes.find( t => t === value);
            return maybeType !== undefined;
        },
        name: (value:string) =>  basicValidation.resourceText.isValid(value, false, 100),
        role: (value:string) =>  basicValidation.resourceText.isValid(value, true, 100),
        email: (value:string) => basicValidation.isValidEmail(value, true),
        phone: (value:string) =>  basicValidation.resourceText.isValid(value, true, 100)
    },
};